"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M14 3c-.28 0-.53.11-.71.29L6 10.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l8-8A1.003 1.003 0 0014 3z"];
//# sourceMappingURL=tick.js.map